export const SET_OPERATION_PROPERTY = 'SET_OPERATION_PROPERTY';
export const UPDATE_CONTACT_PROSPECT = 'UPDATE_CONTACT_PROSPECT';
export const UPDATE_OPERATION_DATA = 'UPDATE_OPERATION_DATA';
export const SET_PATCH_OPERATION_FIELD = 'SET_PATCH_OPERATION_FIELD';
export const PROSPECT_TRANSFORM_PATCH_OPERATION = 'PROSPECT_TRANSFORM_PATCH_OPERATION';
export const CANCEL_OPERATION = 'CANCEL_OPERATION';
export const VALIDATION_STOCK = 'VALIDATION_STOCK';
export const GET_DOCUMENTS = 'GET_DOCUMENTS';
export const VALIDATE_DOCUMENT = 'VALIDATE_DOCUMENT';
